exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-item[data-v-2b148633] {\n  display: inline;\n}\n", ""]);

// exports
